import React from "react";
import Button from "@mui/material/Button";

interface SnNumPadButtonProps {
  text: string;
  onClick: () => void;
  inputRef?: any;
}

// 살짝 밝은 남색 계열 + 어두운 현장에서도 읽히는 대비 유지
const PRIMARY = "#2f4f8f"; // 숫자 키 (밝은 네이비)
const PRIMARY_HOVER = "#3a5fa8";
const PRIMARY_ACTIVE = "#24407a";
const ACTION = "#2f4f8f"; // 기능 키 글자/포인트
const ACTION_BG = "#d6e0f5";
const ACTION_HOVER = "#c3d1ee";
const isActionKey = (text: string) => !/^\d$/.test(text);

export function SnNumPadButton({
  text,
  onClick,
  inputRef,
}: SnNumPadButtonProps) {
  const action = isActionKey(text);
  return (
    <Button
      ref={inputRef}
      disableRipple
      disableElevation
      onClick={onClick}
      sx={{
        width: "100%",
        height: "100%",
        minWidth: 0,
        padding: 0,
        border: "none",
        borderRadius: "16px",
        fontSize: action ? "19px" : "24px",
        fontWeight: 700,
        lineHeight: 1,
        textTransform: "none",
        color: action ? ACTION : "#ffffff",
        backgroundColor: action ? ACTION_BG : PRIMARY,
        boxShadow: action ? "none" : "0 4px 12px rgba(47,79,143,0.28)",
        transition:
          "background-color 120ms ease, box-shadow 120ms ease, transform 100ms ease",
        "&:hover": {
          backgroundColor: action ? ACTION_HOVER : PRIMARY_HOVER,
          boxShadow: action ? "none" : "0 4px 14px rgba(47,79,143,0.34)",
        },
        "&:active": {
          backgroundColor: action ? ACTION : PRIMARY_ACTIVE,
          color: "#ffffff",
          boxShadow: "none",
          transform: "scale(0.96)",
        },
        "&.Mui-focusVisible": {
          boxShadow: `0 0 0 3px #ffffff, 0 0 0 5px ${PRIMARY}`,
        },
      }}
    >
      {text}
    </Button>
  );
}

export default React.memo(SnNumPadButton);
